const CONTENT_OBJECT_TYPE_DEFINITION = {
  name: 'CONTENT',
  metaType: 'HUBSPOT',
  metaTypeId: 0,
  hasCustomProperties: false,
  hasDefaultProperties: true,
  hasPipelines: false,
  hasOwners: false,
  hasExternalObjectIds: false,
  restorable: false,
  deleted: false,
  indexedForFiltersAndReports: false,
  defaultSearchPropertyNames: [],
  requiredProperties: [],
  primaryDisplayLabelPropertyName: 'hs_name',
  secondaryDisplayLabelPropertyNames: [],
  integrationAppId: -1,
  ownerPortalId: -1,
  singularForm: 'content',
  pluralForm: 'content',
  readScopeName: '',
  writeScopeName: '',
  accessScopeName: '',
  janusGroup: 'hs-cms-publishing-be',
  description: null,
  permissioningType: 'DO_NOT_CHECK_PERMISSIONS',
  scopeMappings: [],
  id: 10,
  createDatePropertyName: 'hs_createdate',
  lastModifiedPropertyName: 'hs_lastmodifieddate',
  pipelinePropertyName: 'hs_pipeline',
  pipelineStagePropertyName: 'hs_pipeline_stage',
  pipelineCloseDatePropertyName: '',
  pipelineTimeToClosePropertyName: '',
  fullyQualifiedName: 'CONTENT',
  objectTypeId: '0-10'
};
export default CONTENT_OBJECT_TYPE_DEFINITION;